import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as HostingVisitsAction from '../actions/hosting-visits.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LoadHostingVisitsByWebsiteByDate} from "../actions";
import {DbStoreState} from "../reducers";
import {Store} from "@ngrx/store";

@Injectable()
export class HostingVisitsEffect {

  loadHostingVisits$ = createEffect(() => this._actions$.pipe(
    ofType(HostingVisitsAction.LOAD_HOSTING_VISITS),
    mergeMap((action: any) => {
      return this._hostingService.getHostingVisits(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new HostingVisitsAction.LoadHostingVisitsSuccess({
                entities: response.data
              });
            }
            return new HostingVisitsAction.LoadHostingVisitsFail(response.message);
          })
        );
    })
  ));

  /*@Effect() loadUserSuccess$ = this._actions$.ofType(userActions.LOAD_USER_SUCCESS)
    .pipe(
      filter((loadUserSuccess: LoadUserSuccess) => !!loadUserSuccess.payload),
      switchMap((response: any) => {
        return this._store.select(fromStore.getWebsitesLoaded)
          .pipe(
            filter((response: any) => response),
            switchMap(() => this._store.select(fromStore.getHostedWebsites)),
            filter((response: any) => !!(response.length)),
            map(() => response)
          );
      }),
      map((loadUserSuccess: LoadUserSuccess) => {
        if (loadUserSuccess.payload.agreement && loadUserSuccess.payload.agreement.plan.services && loadUserSuccess.payload.agreement.plan.services.hosting) {
          return new HostingVisitsAction.LoadHostingVisits();
        }
        return new HostingVisitsAction.LoadHostingVisitsFail("There is no hosting services");
      })
    );*/

  /*@Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
    .pipe(
      filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
      switchMap((action: UpdateWebsiteSubData) => [
          new HostingVisitsAction.LoadHostingVisits(),
          new HostingVisitsAction.LoadHostingVisitsByWebsiteByDate({websiteId: action.payload.id, date: null})
      ])
    );*/

  loadHostingVisitsByWebsiteByDate$ = createEffect(() => this._actions$.pipe(
    ofType(HostingVisitsAction.LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE),
    mergeMap((action: LoadHostingVisitsByWebsiteByDate) => {
      return this._hostingService.getHostingVisitsByWebsiteByDate(action.payload.websiteId, action.payload.date)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new HostingVisitsAction.LoadHostingVisitsByWebsiteByDateSuccess({
                websiteId: action.payload.websiteId,
                entities: {
                  data: response.data,
                  sum: response.response.body.sum,
                  start_date: response.response.body.start_date,
                  end_date: response.response.body.end_date
                }
              });
            }
            return new HostingVisitsAction.LoadHostingVisitsByWebsiteByDateFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
